export default __webpack_public_path__ + "static/media/appointment.72025db5.JPG";